import React, {useEffect, useState} from 'react';
import { AtGrid } from 'taro-ui';
import styled from "styled-components";
const AtGridWrapper = styled.div<{
  fontSize: string,
  color: string
}>`
  height: 100%;
  overflow: hidden;
  .at-grid__flex .content-inner__text{
    font-size: ${({fontSize})=> fontSize}!important;
    color: ${({color})=> color};
  }

`
const TGridWidget = (props:any) => {
  const {currentData, onItemClick, columnNum, fontSize, color} = props;
  const [gridData, setGridData] = useState([]);
  useEffect(()=>{
    if(currentData&&currentData.length > 0){
      setGridData(currentData.map((i:any)=>{
        return {
          ...i,
          image: i.url,
          value: i.description
        }
      }))
    }else{
      setGridData([]);
    }
  }, [currentData]);
  return (
    <AtGridWrapper fontSize={fontSize} color={color}>
      <AtGrid columnNum={columnNum} data={gridData} onClick={(item:any)=>{
        onItemClick&&onItemClick(item);
      }} />
    </AtGridWrapper>
  );
};

export default TGridWidget;
